
const little_guys = [,
        {
        title: "Budesonide",
        href: 'https://finaloutpost.net/view/xjjg7/',
        src: "https://finaloutpost.net/s/xjjg7.png",
        category: 'final outpost'
    },
        {
        title: "Gloopy",
        href: 'https://dragcave.net/view/08mJV',
        src: "https://dragcave.net/image/08mJV.gif",
        category: 'dragcave'
    },
    {
        title: "Cetaphil Lotion",
        href: 'https://dragcave.net/view/Z6bHY',
        src: "https://dragcave.net/image/Z6bHY.gif",
        category: 'dragcave'
    },
    {
        title: "Lysol Mango",
        href: 'https://dragcave.net/view/2Fh3d',
        src: "https://dragcave.net/image/2Fh3d.gif",
        category: 'dragcave'
    },
    {
        title: "Nyrod",
        href: 'https://finaloutpost.net/view/NyRQD/',
        src: "https://finaloutpost.net/s/NyRQD.png",
        category: 'final outpost'
    },
    {
        title: "Melon Soda",
        href: 'https://dragcave.net/view/Pxy0M',
        src: "https://dragcave.net/image/Pxy0M.gif",
        category: 'dragcave'
    },
    {
        title: "Walmartholemew II",
        href: 'https://dragcave.net/view/RO8T3',
        src: "https://dragcave.net/image/RO8T3.gif",
        category: 'dragcave'
    },
    {
        title: "BITCH",
        href: 'https://finaloutpost.net/view/bhTC4/',
        src: "https://finaloutpost.net/s/bhTC4.png",
        category: 'final outpost'
    },
    {
        title: "6 YAOI",
        href: 'https://finaloutpost.net/view/6TA0I/',
        src: "https://finaloutpost.net/s/6TA0I.png",
        category: 'final outpost'
    },
    {
        title: "Sneetle",
        href: 'https://finaloutpost.net/view/pxy85/',
        src: "https://finaloutpost.net/s/pxy85.png",
        category: 'final outpost'
    },
      {
        title: "Snottle",
        href: 'https://finaloutpost.net/view/exTEX/',
        src: "https://finaloutpost.net/s/exTEX.png",
        category: 'final outpost'
    },
    {
        title: "Yarp",
        href: 'https://finaloutpost.net/view/Z1JfN/',
        src: "https://finaloutpost.net/s/Z1JfN.png",
        category: 'final outpost'
    },
    {
        title: "New Type of Dog",
        href: 'https://dragcave.net/view/tfLFs',
        src: "https://dragcave.net/image/tfLFs.gif",
        category: 'dragcave'
    },
    {
        title: "Loathesome Dung-eater",
        href: 'https://dragcave.net/view/rQFMy',
        src: "https://dragcave.net/image/rQFMy.gif",
        category: 'dragcave'
    },
    {
        title: "Smartpanel 2",
        href: 'https://dragcave.net/view/VsrUz',
        src: "https://dragcave.net/image/VsrUz.gif",
        category: 'dragcave'
    },
    {
        title: "Gortholax the Destroyer",
        href: 'https://dragcave.net/view/9O9fC',
        src: "https://dragcave.net/image/9O9fC.gif",
        category: 'dragcave'
    },
]

export default little_guys;